// Motion and touch feedback shared by expandable cards: the mobile table cards and the Picture-in-Picture rows.

export const touchButtonSx = {
  transition: 'transform 120ms ease, opacity 120ms ease',
  '&:active': { transform: 'scale(0.97)' },
} as const;

/** A `<button>` wrapping a card's summary row, so the whole row is the tap target; layout is the caller's. */
export const cardSummaryButtonSx = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
  bgcolor: 'transparent',
  border: 0,
  borderRadius: 'inherit',
  outline: 'none',
  color: 'inherit',
  textAlign: 'left',
  transition: 'background-color 160ms ease',
  '&:focus-visible': { bgcolor: 'action.hover' },
  '&:active': { bgcolor: 'action.hover' },
} as const;

export const chevronSx = {
  color: 'text.secondary',
  flexShrink: 0,
  transition: 'transform 280ms cubic-bezier(0.2, 0.8, 0.2, 1)',
} as const;

export const chevronOpenSx = {
  ...chevronSx,
  transform: 'rotate(180deg)',
} as const;

export const collapseTimeout = { enter: 280, exit: 200 } as const;

export const collapseSx = {
  width: '100%',
  '& .MuiCollapse-wrapper, & .MuiCollapse-wrapperInner': {
    overflow: 'visible',
  },
} as const;
